module.exports = "/lucky-balls/img/combos-sr/81.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos-sr/81.png
// module id = 995
// module chunks = 0